import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-6">
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/invictus-green/uploads/a3c3bfe4-4b9e-4361-a33e-f6ae6cbf79b3.jpeg`}
                alt="RESCO Invictus Green Energy Solutions"
                className="h-36 w-36 object-contain rounded-lg"
              />
              <div className="ml-4">
                <span className="text-xl font-bold text-white block">INVICTUS GREEN</span>
                <span className="text-sm text-white/60 tracking-[0.15em] uppercase">Energy Solutions LLP</span>
              </div>
            </div>
            <p className="text-white/80 leading-relaxed max-w-md">
              Leading provider of C&I Solar Power Plant solutions. We specialize in Financing, Designing, Installing, Commissioning, and Operation & Maintenance of commercial and industrial solar power systems.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <Link to="/" className="block text-white/80 hover:text-accent transition-colors" data-testid="footer-link-home">
                Home
              </Link>
              <Link to="/about" className="block text-white/80 hover:text-accent transition-colors" data-testid="footer-link-about">
                About Us
              </Link>
              <Link to="/projects" className="block text-white/80 hover:text-accent transition-colors" data-testid="footer-link-projects">
                Running Projects
              </Link>
              <Link to="/blog" className="block text-white/80 hover:text-accent transition-colors" data-testid="footer-link-blog">
                Blog & News
              </Link>
              <Link to="/contact" className="block text-white/80 hover:text-accent transition-colors" data-testid="footer-link-contact">
                Contact Us
              </Link>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-1 text-accent flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="mailto:invictuspowersolutions@gmail.com" className="text-white/80 hover:text-accent transition-colors text-sm" data-testid="footer-email">
                    invictuspowersolutions@gmail.com
                  </a>
                  <a href="mailto:admin@invictusgreen.ooo" className="text-white/80 hover:text-accent transition-colors text-sm" data-testid="footer-email-2">
                    admin@invictusgreen.ooo
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="mt-1 text-accent flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+918015600003" className="text-white/80 hover:text-accent transition-colors text-sm" data-testid="footer-phone">
                    +91 8015600003
                  </a>
                  <a href="tel:+919872802140" className="text-white/80 hover:text-accent transition-colors text-sm" data-testid="footer-phone-2">
                    +91 9872802140
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 text-accent flex-shrink-0" />
                <span className="text-white/80 text-sm" data-testid="footer-address">
                  555-A Model Town Extension,<br />Ludhiana-141002, Punjab, India
                </span>
              </li>
            </ul>
            <div className="mt-4">
              <a href="https://www.invictusgreens.in" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-white transition-colors text-sm font-medium" data-testid="footer-website">
                www.invictusgreens.in
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} RESCO Invictus Green Energy Solutions LLP. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
